import { getInfoAll } from '../../api/endpoints/products';

export const state = {
  data: [],
}

export const getters = {
  tableData: s => s.data
}

export const mutations = {
  GET_DATA(state) {
    getInfoAll().then( res => {
      state.data = res.data.data
    })
  }
}

export const actions = {
  getData({commit}) {
    commit('GET_DATA')
  }
}